import * as React from "react";

export const FinalBidAmountWarning = ({ finalBidAmount }: { finalBidAmount: number }) => {
    if (!!finalBidAmount && (finalBidAmount > 220000 || finalBidAmount < 1000)) {
        return (
            <div className="form-row mb-3">
                <div className="col-12">
                    <div className="alert alert-warning text-center">Please check the Bid Amount value. It should be between $1,000 and $220,000</div>
                </div>
            </div>
        );
    } else {
        return <div />;
    }
};



// WEBPACK FOOTER //
// ./src/components/common/FinalBidAmountWarning.tsx